class AboutServices {
    constructor({ text, text_en }) {
        this.text = text
        this.textEn = text_en

    }
}

export default AboutServices